import { useSelector, useDispatch } from 'react-redux';
import { selectModalById } from 'Core/redux/main/selectors';
import { closeModal } from 'Core/redux/main/slice';
import { modalRegistry } from './modal-registry';
import { useEffect, useCallback } from 'react';

export const useModal = modalId => {
  if (!modalId) {
    throw new Error('modalId is required for useModal hook');
  }

  const modal = useSelector(state => {
    return selectModalById(modalId, state);
  });

  const dispatch = useDispatch();
  const onCloseModal = useCallback(() => {
    dispatch(closeModal(modalId));
  }, [dispatch, modalId]);

  useEffect(() => {
    modalRegistry.register(modalId);
    return () => {
      modalRegistry.deregister(modalId);
    };
  }, [modalId]);

  return [modal ? true : false, modal ? modal.data : null, onCloseModal];
};
